<form class="option-field">
  <ds-auto-complete>
    <ds-option
      class="ds-option-borders"
      [value]="option.text"
      [class.disabled]="option.noAddressFound"
      (click)="optionClicked(option.text)"
      *ngFor="let option of filteredOptions"
    >
      <span class="ds-option-text" [innerHTML]="option.text">{{
        option.text
      }}</span>
    </ds-option>
  </ds-auto-complete>
</form>
